import React from 'react';
import { useAuth } from '@/features/auth/AuthProvider';
import { useTranslation } from 'react-i18next';
import { formatEgp, UNDECIDED_PLAN } from '@/lib/plans';

interface Props {
    onBack?: () => void;
}

export const PendingApprovalScreen: React.FC<Props> = ({ onBack }) => {
    const { t, i18n } = useTranslation();
    const { currentUser } = useAuth();

    return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] text-center p-6 space-y-6">
            <div className="w-24 h-24 bg-yellow-50 rounded-full flex items-center justify-center mb-4">
                {/* eslint-disable-next-line i18next/no-literal-string -- visual hourglass emoji */}
                <span className="text-4xl">⏳</span>
            </div>

            <div className="space-y-2 max-w-md">
                <h2 className="text-2xl font-bold text-gray-900">
                    {t('onboarding.pending.title')}
                </h2>
                <p className="text-gray-600">
                    {t('onboarding.pending.thanks', { name: currentUser?.displayName?.split(' ')[0] || '' })}
                </p>
                <p className="text-gray-500 text-sm">
                    {t('onboarding.pending.received_details')}
                </p>
            </div>

            {currentUser?.requestedPlanId && currentUser.requestedPlanId !== UNDECIDED_PLAN && (
                <div className="bg-amber-50 border border-amber-100 rounded-lg p-4 text-sm text-amber-900 max-w-sm space-y-1" dir="auto">
                    <p><strong>{t('signup.pending.your_plan')}</strong></p>
                    <p>{t('signup.pending.plan_line', { name: currentUser.requestedPlanName, price: formatEgp(currentUser.requestedPlanPrice ?? 0, i18n.language) })}</p>
                    <p className="text-amber-800">{t('signup.pending.pay_at_academy')}</p>
                </div>
            )}
            {currentUser?.requestedPlanId === UNDECIDED_PLAN && (
                <div className="bg-amber-50 border border-amber-100 rounded-lg p-4 text-sm text-amber-900 max-w-sm" dir="auto">
                    <p>{t('signup.pending.undecided')}</p>
                </div>
            )}

            <div className="bg-blue-50 border border-blue-100 rounded-lg p-4 text-sm text-blue-800 max-w-sm">
                <p>
                    <strong>{t('onboarding.pending.what_next_q')}</strong><br />
                    {t('onboarding.pending.close_page')}
                </p>
            </div>

            <div className="pt-4">
                {onBack && (
                    <button
                        onClick={onBack}
                        className="text-sm text-gray-500 hover:text-gray-900 underline"
                    >
                        {t('onboarding.pending.review_selections')}
                    </button>
                )}
            </div>
        </div>
    );
};
